import { useIsStale } from "../lib/version-check.ts";

/**
 * Shown when a newer build is deployed while this tab is open. One line, fixed at the bottom, above
 * everything, and it does not block the page: the next change of page reloads anyway.
 */
export function UpdateBar() {
  const stale = useIsStale();
  if (!stale) return null;
  return (
    <output className="fixed inset-x-0 bottom-4 z-[60] mx-auto flex w-fit max-w-[calc(100%-32px)] items-center gap-3 rounded-pill bg-ink px-4 py-2.5 text-sm text-inverse shadow-card">
      <span>A new version of Teamna is ready.</span>
      <button
        type="button"
        className="rounded-pill bg-inverse px-3 py-1 font-semibold text-ink"
        onClick={() => window.location.reload()}
      >
        Reload
      </button>
    </output>
  );
}
